/* eslint-disable */
import apiHelper from '@utils/cunstomInterseptor'

const HEARTBEAT_INTERVAL_MS = 25000
const BASE_RECONNECT_DELAY_MS = 2000
const MAX_RECONNECT_DELAY_MS = 30000
const WS_LOG_PREFIX = '[AML_WS]'

function convertTime (time) {
  const data = time;
  const milliseconds = Math.floor(Number(data) * 1000);
  const date = new Date(milliseconds);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const year = date.getFullYear().toString().slice(2);
  return `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`
}

function getDeviceId () {
  if (!sessionStorage.getItem('device_id')) {
    sessionStorage.setItem('device_id', Date.now())
  }
  return String(JSON.parse(sessionStorage.getItem('device_id')))
}

function buildInitialRequest (state) {
  return {
    type: 'initialRequest',
    token: sessionStorage.getItem('token'),
    device_id: getDeviceId(),
    last_event_id: state.lastEventId
  }
}

function buildHeartbeatRequest () {
  return { type: 'ping' }
}

function safeSend (ws, payload) {
  if (!ws || ws.readyState !== WebSocket.OPEN) return false

  try {
    ws.send(JSON.stringify(payload))
    return true
  } catch (e) {
    console.error(`${WS_LOG_PREFIX} send error`, e)
    return false
  }
}

function nextReconnectDelay (attempt) {
  const delay = BASE_RECONNECT_DELAY_MS * Math.pow(2, attempt)
  return Math.min(delay, MAX_RECONNECT_DELAY_MS)
}

function getInitialState () {
  return {
    amlinc: [],
    lymit: [],
    amlout: [],
    amlouterror: [],
    amlincerror: [],
    isConnected: false,
    ws: null,
    deviceId: null,
    lastEventId: 0,
    pingInterval: null,
    reconnectTimeout: null,
    reconnectAttempts: 0,
    shouldReconnect: true
  }
};

export const state = getInitialState()

export const mutations = {
  SET_LOGGED_OUT_STATE (state) {
    if (state.ws && (state.ws.readyState === WebSocket.OPEN || state.ws.readyState === WebSocket.CONNECTING)) {
      state.ws.close()
    }
    if (state.pingInterval) {
      clearTimeout(state.pingInterval)
    }
    if (state.reconnectTimeout) {
      clearTimeout(state.reconnectTimeout)
    }
    Object.assign(state, getInitialState())
  },
  CLEAR_INTERVAL (state) {
    if (state.pingInterval) {
      clearTimeout(state.pingInterval)
      state.pingInterval = null
    }
  },
  SET_INTERVAL (state, intervalId) {
    state.pingInterval = intervalId
  },
  CLEAR_RECONNECT_TIMEOUT (state) {
    if (state.reconnectTimeout) {
      clearTimeout(state.reconnectTimeout)
      state.reconnectTimeout = null
    }
  },
  SET_RECONNECT_TIMEOUT (state, timeoutId) {
    state.reconnectTimeout = timeoutId
  },
  RESET_RECONNECT_ATTEMPTS (state) {
    state.reconnectAttempts = 0
  },
  INCREMENT_RECONNECT_ATTEMPTS (state) {
    state.reconnectAttempts += 1
  },
  SET_SHOULD_RECONNECT (state, value) {
    state.shouldReconnect = value
  },
  SET_AML_INC_NOTIFICATION(state, data) {
    state.amlinc.push(data);
    state.amlinc = state.amlinc.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlinc.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_LYMIT_NOTIFICATION(state, data) {
    state.lymit.push(data);
    state.lymit = state.lymit.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.lymit.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_ERROR_INC_NOTIFICATION(state, data) {
    state.amlincerror.push(data);
    state.amlincerror = state.amlincerror.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlincerror.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_ERROR_OUT_NOTIFICATION(state, data) {
    state.amlouterror.push(data);
    state.amlouterror = state.amlouterror.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlouterror.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  SET_AML_OUT_NOTIFICATION(state, data) {
    state.amlout.push(data);
    state.amlout = state.amlout.filter((value, index, self) =>
      index === self.findIndex((t) => t.notif_id === value.notif_id)
    )
    state.amlout.sort((a, b) => {
      const parseDate = str => {
        const [date, time] = str.split(', ')
        const [day, month, year] = date.split('.')
        return new Date(`20${year}-${month}-${day}T${time}`)
      };

      return parseDate(b.timeStamp) - parseDate(a.timeStamp)
    })
  },
  CLEAR_NOTIFICATIONS(state) {
    state.amlout = [];
    state.lymit = [];
    state.amlinc = [];
    state.amlouterror = [];
    state.amlincerror = [];
  },
  DELETE_LYMIT(state, id) {
    state.lymit = state.lymit.filter(el => el.notif_id !== id);
  },
  DELETE_AML_INC(state, id) {
    state.amlinc = state.amlinc.filter(el => el.notif_id !== id);
  },
  DELETE_AML_OUT(state, id) {
    state.amlout = state.amlout.filter(el => el.notif_id !== id);
  },
  DELETE_ERROR_INC(state, id) {
    state.amlincerror = state.amlincerror.filter(el => el.notif_id !== id);
  },
  DELETE_ERROR_OUT(state, id) {
    state.amlouterror = state.amlouterror.filter(el => el.notif_id !== id);
  },
  DELETE_DEAD_NOTIFICATIONS (state, ids) {
    state.amlinc = state.amlinc.filter(el => !ids.includes(el.notif_id))
    state.amlout = state.amlout.filter(el => !ids.includes(el.notif_id))
    state.lymit = state.lymit.filter(el => !ids.includes(el.notif_id))
    state.amlouterror = state.amlouterror.filter(el => !ids.includes(el.notif_id))
    state.amlincerror = state.amlincerror.filter(el => !ids.includes(el.notif_id))
  },
  SET_CONNECTION_STATUS(state, data) {
    state.isConnected = data
  },
  SET_LAST_EVENT(state, data) {
    state.lastEventId = data
  },
  SET_WS(state, ws) {
    state.ws = ws;
  },
};

export const actions = {
  async deleteNotificationById({ commit, rootState }, obj) {
    if (obj.type === 1) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_LYMIT", obj.notif_id)
    }
    if (obj.type === 2) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_AML_INC", obj.notif_id)
    }
    if (obj.type === 3) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_AML_OUT", obj.notif_id)
    }
    if (obj.type === -1) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_ERROR_INC", obj.notif_id)
    }
    if (obj.type === -2) {
      apiHelper.delete(`/delete_notification/${obj.notif_id}`)
      commit("DELETE_ERROR_OUT", obj.notif_id)
    }
  },

  async getExistMessages({commit, rootState}) {
    const { data } = await apiHelper.get(`/get_notifications`)
    if (data && data.notifications) {
      for (let i = 0; i < data.notifications.length; i++) {
        if (data.notifications[i].type === 1) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.id = data.notifications[i].id
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit("SET_LYMIT_NOTIFICATION", data.notifications[i].data);
        } else if (data.notifications[i].type === 2) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit('SET_AML_INC_NOTIFICATION', data.notifications[i].data)
        } else if (data.notifications[i].type === 3) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit("SET_AML_OUT_NOTIFICATION", data.notifications[i].data);
        } else if (data.notifications[i].type === -1) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit('SET_ERROR_INC_NOTIFICATION', data.notifications[i].data)
        } else if (data.notifications[i].type === -2) {
          data.notifications[i].data.timeStamp = convertTime(data.notifications[i].created_at)
          data.notifications[i].data.type = data.notifications[i].type
          data.notifications[i].data.notif_id = data.notifications[i].id
          commit('SET_ERROR_OUT_NOTIFICATION', data.notifications[i].data)
        }
      }
    }
    if (data.last_event_id) {
      commit('SET_LAST_EVENT', data.last_event_id)
    }
  },
  async getAMLMessages({ commit, state, dispatch, rootState }) {
    if (state.isConnected || (state.ws && state.ws.readyState === WebSocket.CONNECTING)) {
      return
    }

    commit('SET_SHOULD_RECONNECT', true)
    commit('CLEAR_RECONNECT_TIMEOUT')

    dispatch('disconect', { shouldReconnect: true })

    const ws = new WebSocket(
      `${process.env.USDT_WEBSOCKET_LISTENER}/ws_notifications`
    )

    commit('SET_WS', ws)

    function scheduleHeartbeat () {
      commit('CLEAR_INTERVAL')
      const timeoutId = setTimeout(() => {
        if (!safeSend(ws, buildHeartbeatRequest())) {
          console.warn(`${WS_LOG_PREFIX} heartbeat send failed, closing socket`)
          if (ws.readyState === WebSocket.OPEN) {
            ws.close()
          }
          return
        }
        scheduleHeartbeat()
      }, HEARTBEAT_INTERVAL_MS)
      commit('SET_INTERVAL', timeoutId)
    }

    function cleanupSocket () {
      commit('CLEAR_INTERVAL')
      ws.removeEventListener('open', ws._openHandler)
      ws.removeEventListener('message', ws._messageHandler)
      ws.removeEventListener('close', ws._closeHandler)
      ws.removeEventListener('error', ws._errorHandler)
      if (state.ws === ws) {
        commit('SET_WS', null)
      }
    }

    function open () {
      commit('SET_CONNECTION_STATUS', true)
      commit('RESET_RECONNECT_ATTEMPTS')
      if (!safeSend(ws, buildInitialRequest(state))) {
        console.warn(`${WS_LOG_PREFIX} initialRequest send failed, closing socket`)
        ws.close()
        return
      }
      scheduleHeartbeat()
    }

    function message (event) {
      scheduleHeartbeat()
      let data = null
      try {
        data = JSON.parse(event.data)
      } catch (e) {
        console.error(`${WS_LOG_PREFIX} parse error`, e)
        return
      }
      if (data === 401) {
        dispatch('disconect', { shouldReconnect: false })
        dispatch('LOG_OUT')
        return
      }
      if (data && data.type === 'pong') {
        return
      }
      if (data.last_event_id > state.lastEventId) {
        commit('SET_LAST_EVENT', data.last_event_id)
        safeSend(ws, {type: 'ack', payload: {last_event_id: data.last_event_id}})
        const notifications = data.notifications || []
        commit('DELETE_DEAD_NOTIFICATIONS', data.deleted_ids || [])
        for (let i = 0; i < notifications.length; i++) {
          if (notifications[i].type === 1) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.id = notifications[i].id
            notifications[i].data.notif_id = notifications[i].id
            commit('SET_LYMIT_NOTIFICATION', notifications[i].data)
          } else if (notifications[i].type === 2) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit('SET_AML_INC_NOTIFICATION', notifications[i].data)
          } else if (notifications[i].type === 3) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit('SET_AML_OUT_NOTIFICATION', notifications[i].data)
          } else if (notifications[i].type === -1) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit('SET_ERROR_INC_NOTIFICATION', notifications[i].data)
          } else if (notifications[i].type === -2) {
            notifications[i].data.timeStamp = convertTime(notifications[i].created_at)
            notifications[i].data.type = notifications[i].type
            notifications[i].data.notif_id = notifications[i].id
            commit('SET_ERROR_OUT_NOTIFICATION', notifications[i].data)
          }
        }
      }
    }

    function close (event) {
      console.warn(`${WS_LOG_PREFIX} close`, {
        code: event && event.code,
        reason: event && event.reason,
        wasClean: event && event.wasClean
      })
      commit('SET_CONNECTION_STATUS', false)
      cleanupSocket()

      if (!state.shouldReconnect) return

      const delay = nextReconnectDelay(state.reconnectAttempts)
      commit('INCREMENT_RECONNECT_ATTEMPTS')

      const timeoutId = setTimeout(() => {
        dispatch('getAMLMessages')
      }, delay)
      commit('SET_RECONNECT_TIMEOUT', timeoutId)
    }

    function error (event) {
      console.error(`${WS_LOG_PREFIX} error`, event)
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close()
      }
    }

    ws._openHandler = open
    ws._messageHandler = message
    ws._closeHandler = close
    ws._errorHandler = error

    ws.addEventListener('open', open)
    ws.addEventListener('message', message)
    ws.addEventListener('close', close)
    ws.addEventListener('error', error)
  },
  disconect ({ commit, state }, { shouldReconnect = false } = {}) {
    commit('SET_SHOULD_RECONNECT', shouldReconnect)
    commit('CLEAR_INTERVAL')
    commit('CLEAR_RECONNECT_TIMEOUT')

    const currentWs = state.ws
    if (currentWs) {
      currentWs.removeEventListener('open', currentWs._openHandler)
      currentWs.removeEventListener('message', currentWs._messageHandler)
      currentWs.removeEventListener('close', currentWs._closeHandler)
      currentWs.removeEventListener('error', currentWs._errorHandler)
      if (currentWs.readyState === WebSocket.OPEN || currentWs.readyState === WebSocket.CONNECTING) {
        currentWs.close()
      }
      commit('SET_WS', null)
    }
    commit('SET_CONNECTION_STATUS', false)
  }
};

export const getters = {
  getUnreadLymit: state => state.lymit,
  getUnreadInc: state => state.amlinc,
  getUnreadOut: state => state.amlout,
  getUnreadErrorInc: state => state.amlincerror,
  getUnreadErrorOut: state => state.amlouterror,
  getConnectionStatus: state => state.isConnected
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/vuex/modules/amlNotification.module.js